/* category scroll hero */

(function () {
  'use strict';

  var ROOT = '[data-cat-hero]';
  var NUMBER_GAP = 14;
  var ACTIVE_RATIO = 0.55;

  var NBSP = String.fromCharCode(160);

  var instances = {};

  function wrapChars(container) {
    var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    var node;
    while ((node = walker.nextNode())) textNodes.push(node);

    textNodes.forEach(function (tn) {
      var frag = document.createDocumentFragment();
      var i = 0;
      tn.textContent.split('').forEach(function (ch) {
        var span = document.createElement('span');
        span.className = 'cat-hero__ch';
        span.style.setProperty('--i', i++);
        span.textContent = ch === ' ' ? NBSP : ch;
        frag.appendChild(span);
      });
      tn.parentNode.replaceChild(frag, tn);
    });
  }

  function attach(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cat-hero-item]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cat-hero-panel]'));
    if (!items.length || !panels.length) return null;

    var total = panels.length;
    var trackEl = root.querySelector('[data-cat-hero-track]');
    var currentEl = root.querySelector('[data-cat-hero-current]');
    var barEl = root.querySelector('[data-cat-hero-bar]');
    var totalEl = root.querySelector('[data-cat-hero-total]');
    var hasProgress = !!(trackEl && currentEl && barEl && totalEl) && total > 1;
    var mobileMq = window.matchMedia('(max-width: 749px)');

    function videoIn(panel) {
      var want = mobileMq.matches ? 'mobile' : 'desktop';
      return panel.querySelector(
        '[data-cat-hero-video="' + want + '"],[data-cat-hero-video="both"]'
      );
    }

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    var itemByTarget = {};
    items.forEach(function (item) {
      itemByTarget[item.getAttribute('data-target')] = item;
      wrapChars(item);
    });

    var lastIndex = null;

    function pulseReveal(item) {
      item.classList.remove('is-revealing');
      void item.offsetWidth;
      item.classList.add('is-revealing');
    }

    function goTo(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({
        behavior: reduceMotion.matches ? 'instant' : 'smooth',
        block: 'start',
      });
    }

    function setActive(index) {
      var panel = panels[index - 1];
      var match = panel ? itemByTarget[panel.id] : null;

      items.forEach(function (item) {
        item.classList.remove('is-active');
      });
      if (match) match.classList.add('is-active');

      if (hasProgress) {
        var trackHeight = trackEl.getBoundingClientRect().height;
        var fraction = Math.max((total - index) / (total - 1), 0);
        var barHeight = fraction * trackHeight;
        var atEnd = index >= total;

        currentEl.textContent = index;
        barEl.style.height = barHeight + 'px';
        currentEl.style.bottom = barHeight + NUMBER_GAP + 'px';
        currentEl.classList.toggle('is-hidden', atEnd);
        barEl.classList.toggle('is-hidden', atEnd);
        totalEl.classList.toggle('is-active', atEnd);
      }

      if (index !== lastIndex) {
        if (match) pulseReveal(match);
        lastIndex = index;
      }
    }

    function onEnter(event) {
      if (!finePointer.matches) return;
      goTo(event.currentTarget.getAttribute('data-target'));
    }

    function navigatesOnTap(item) {
      return item.hasAttribute('href') && !finePointer.matches;
    }

    function onFocus(event) {
      var item = event.currentTarget;
      if (navigatesOnTap(item)) return;
      goTo(item.getAttribute('data-target'));
    }

    function onClick(event) {
      var item = event.currentTarget;
      if (navigatesOnTap(item) || (item.hasAttribute('href') && item.classList.contains('is-active'))) return;
      event.preventDefault();
      goTo(item.getAttribute('data-target'));
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', onEnter);
      item.addEventListener('focus', onFocus);
      item.addEventListener('click', onClick);
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var panel = entry.target;
          var video = videoIn(panel);

          if (entry.isIntersecting && entry.intersectionRatio >= ACTIVE_RATIO) {
            panel.classList.add('is-in-view');
            setActive(panels.indexOf(panel) + 1);
            if (video) {
              var played = video.play();
              if (played && played.catch) played.catch(function () {});
            }
            return;
          }

          if (video && !video.paused) video.pause();
        });
      },
      { threshold: [0, ACTIVE_RATIO] }
    );

    panels.forEach(function (panel) {
      observer.observe(panel);
    });

    function onResize() {
      if (lastIndex) setActive(lastIndex);
    }

    function onBreakpoint() {
      panels.forEach(function (panel) {
        var all = panel.querySelectorAll('video');
        for (var i = 0; i < all.length; i++) all[i].pause();
        if (!panel.classList.contains('is-in-view')) return;
        var video = videoIn(panel);
        if (!video) return;
        var played = video.play();
        if (played && played.catch) played.catch(function () {});
      });
    }

    window.addEventListener('resize', onResize, { passive: true });
    if (mobileMq.addEventListener) mobileMq.addEventListener('change', onBreakpoint);

    return {
      goTo: goTo,
      destroy: function () {
        observer.disconnect();
        window.removeEventListener('resize', onResize);
        if (mobileMq.removeEventListener) {
          mobileMq.removeEventListener('change', onBreakpoint);
        }
        items.forEach(function (item) {
          item.removeEventListener('mouseenter', onEnter);
          item.removeEventListener('focus', onFocus);
          item.removeEventListener('click', onClick);
        });
      },
    };
  }

  function init() {
    var roots = document.querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var sectionId = root.dataset.sectionId;
      if (!sectionId || instances[sectionId]) continue;

      var controller = attach(root);
      if (controller) instances[sectionId] = controller;
    }
  }

  document.addEventListener('shopify:section:load', init);

  document.addEventListener('shopify:section:unload', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId || !instances[sectionId]) return;
    instances[sectionId].destroy();
    delete instances[sectionId];
  });

  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target;
    if (!panel || !panel.matches || !panel.matches('[data-cat-hero-panel]')) return;
    var root = panel.closest(ROOT);
    var controller = root && instances[root.dataset.sectionId];
    if (controller) controller.goTo(panel.id);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
